import React, { useState, useEffect } from 'react';

import Modal from 'react-modal';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import './App.css';
import content from './content.js';

import appleIIe from "./images/appleIIe.jpg";
import poolrad from "./images/poolrad.jpg";
import ncsamosaic from "./images/ncsamosaic.jpg";
import cprog from "./images/cprog.png";
import college from "./images/college.jpg";
import future from "./images/future.jpg";

Modal.setAppElement('#root');

const App = () => {
  const [activeSection, setActiveSection] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const sections = content;

  const preloadImages = (imageUrls) => {
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  };

  useEffect(() => {
    const imagesToPreload = [
      appleIIe,
      poolrad,
      ncsamosaic,
      cprog,
      college,
      future
    ];
    preloadImages(imagesToPreload);
  }, []);

  const handleCircleClick = (id) => {
    setActiveSection(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveSection(null);
  };

  useEffect(() => {
    let modalContent;
    if (isModalOpen) {
      setTimeout(() => {
        modalContent = document.querySelector(".ReactModal__Content");
        if (modalContent) {
          disableBodyScroll(modalContent);
        }
      }, 0);
    } else {
      modalContent = document.querySelector(".ReactModal__Content");
      if (modalContent) {
        enableBodyScroll(modalContent);
      }
    }

    return () => {
      modalContent = document.querySelector(".ReactModal__Content");
      if (modalContent) {
        enableBodyScroll(modalContent);
      }
    };
  }, [isModalOpen]);

  return (
    <div className="pageDiv">
      <h1 className="pageHeader">
        Clays "Ancient History"
      </h1>

      <div className="timelineContainer">
        <div className="timeline" style={{ position: 'relative' }}>
          {sections.map((section, index) => (
            <div key={section.id} className="timelineItem">
              <div
                className={
                  section.id % 2 === 1
                    ? "timelineDecoratorDiv"
                    : "timelineDecoratorDivInactive"
                }
                onClick={() => handleCircleClick(section.id)}
              >
                {section.id % 2 === 1 ? section.timelineText : null}
              </div>

              <svg className="circleAndLine" width="80" height="150">
                {index < sections.length - 1 && (
                  <line
                    x1="40"
                    y1="58"
                    x2="40"
                    y2="150"
                    stroke="black"
                    strokeWidth="4"
                  />
                )}

                <g
                  className="circleAndText"
                  onClick={() => handleCircleClick(section.id)}
                >
                  <circle
                    cx="40"
                    cy="40"
                    r="38"
                    stroke="black"
                    strokeWidth="3"
                    fill={activeSection === section.id ? 'lightblue' : 'white'}
                  />
                  <text
                    x="30"
                    y="25"
                    textAnchor="middle"
                    fontSize="20"
                    fontWeight="bold"
                    fill="black"
                  >
                    <tspan x="40" dy="10">{section.startYear}-</tspan>
                    <tspan x="40" dy="25">{section.endYear}</tspan>
                  </text>
                </g>
              </svg>

              <div
                className={
                  section.id % 2 === 0
                    ? "timelineDecoratorDiv"
                    : "timelineDecoratorDivInactive"
                }
                onClick={() => handleCircleClick(section.id)}
              >
                {section.id % 2 === 0 ? section.timelineText : null}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: '10px',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflowY: 'auto',
            zIndex: 1100,
            position: 'relative',
          },
        }}
      >
      <button
        onClick={closeModal}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          fontSize: '40px',
          fontWeight: 'bold',
          cursor: 'pointer',
          outline: 'none',
          transition: 'transform 0.2s, color 0.2s',
          color: 'black',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.2)';
          e.target.style.color = '#ff0000';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.color = 'black';
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="40"
          height="40"
        >
          <path
            d="M18.36 5.64L12 12l6.36 6.36-1.72 1.72L12 13.72l-6.36 6.36-1.72-1.72L11.28 12 4.92 5.64l1.72-1.72L12 10.28l6.36-6.36z"
          />
        </svg>
      </button>

        <div>
          {activeSection &&
            sections.find((section) => section.id === activeSection).content}
        </div>
      </Modal>
    </div>
  );
};

export default App;
